export default __webpack_public_path__ + "static/media/second-deposit.f5dc3657.svg";